import React from "react";
import { CheckIcon, FlameIcon, GlobeIcon, LockIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { Countdown } from "./Countdown";
import { images, offerItems } from "../data/landing";
const SPOTS_TOTAL = 100;
const SPOTS_LEFT = 7;
export function Offer() {
  const total = offerItems.reduce((sum, i) => sum + i.value, 0);
  const filled = (SPOTS_TOTAL - SPOTS_LEFT) / SPOTS_TOTAL * 100;
  return <section id="offer" className="bg-navy px-4 py-16 sm:py-20" aria-labelledby="offer-title" data-id="element-202" data-mp="tzda8wbv60h9">
      <div className="mx-auto max-w-2xl" data-id="element-203" data-mp="p11xodu6pbvc">
        <div className="text-center" data-id="element-204" data-mp="13x15dnddt9zy">
          <span className="inline-flex items-center gap-2 rounded-full bg-before px-4 py-1.5 text-[13px] font-extrabold uppercase tracking-wide text-white" data-id="element-205" data-mp="13y2h7u2820iq">
            <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-206" data-mp="2fc6a0wx2pim7" /> Special introductory offer
          </span>
          <h2 id="offer-title" className="mt-4 font-display text-[36px] font-extrabold uppercase leading-[1.02] text-white sm:text-5xl" data-id="element-207" data-mp="2ad3crync4gos">
            Here's everything you'll receive today
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border-2 border-gold bg-ink shadow-[0_20px_60px_-20px_rgba(250,204,21,0.35)]" data-id="element-208" data-mp="uisezht3qywb">
          <img src={images.mockup} alt="Complete Blueprint collection" className="w-full bg-white" loading="lazy" data-id="element-209" data-mp="ziwlqg47kf9c" />

          <div className="p-5 sm:p-8" data-id="element-210" data-mp="13hw0esfqrqdz">
            <ul className="divide-y divide-line" data-id="element-211" data-mp="6u98n7tm4w6v">
              {offerItems.map(item => <li key={item.label} className="flex items-start justify-between gap-4 py-3.5" data-id="element-212" data-mp="bskg5bwfqulx">
                  <span className="flex gap-2.5 text-[15px] font-semibold leading-snug text-white" data-id="element-213" data-mp="funv4aibchby">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-after" strokeWidth={3} aria-hidden="true" data-id="element-214" data-mp="kkvz6cp7zfrv" />
                    {item.label}
                  </span>
                  <span className="shrink-0 text-[15px] font-semibold text-mist line-through" data-id="element-215" data-mp="3k6t426o0ix7r">${item.value}</span>
                </li>)}
            </ul>

            <div className="mt-4 flex items-center justify-between rounded-xl bg-panel px-4 py-3" data-id="element-216" data-mp="ve624bcshrtt">
              <span className="text-[14px] font-bold uppercase tracking-wide text-mist" data-id="element-217" data-mp="qg4k7tr3nyjx">Total reference value</span>
              <span className="font-display text-2xl font-extrabold text-before line-through" data-id="element-218" data-mp="154r0pysgqwcq">${total}</span>
            </div>

            <div className="mt-8 text-center" data-id="element-219" data-mp="cgv5yzmgfeil">
              <p className="text-[15px] font-bold uppercase tracking-wide text-white" data-id="element-220" data-mp="cho3rb3fqtol">Today, get the complete collection for just</p>
              <p className="mt-1 font-display text-[96px] font-extrabold leading-none text-gold sm:text-[120px]" data-id="element-221" data-mp="7jw8c73l0pfn">$27</p>
              <p className="mt-1 text-[15px] font-semibold text-white" data-id="element-222" data-mp="hg7pbae4a3gf">One-time payment · USD</p>
              <p className="mx-auto mt-3 flex max-w-md items-center justify-center gap-2 rounded-xl bg-cyan/15 px-3 py-2 text-[14px] font-semibold text-cyan" data-id="element-223" data-mp="1wwq3p540uzev">
                <GlobeIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-224" data-mp="1sulcse4ykgvx" />
                Currency conversion is automatic — you'll pay in your local currency.
              </p>
            </div>

            <div className="mt-7" data-id="element-225" data-mp="25fbfnhtmczrj">
              <div className="mb-2 flex items-center justify-between gap-3 text-[14px] font-bold" data-id="element-226" data-mp="1qghig2cjwqmn">
                <span className="text-white" data-id="element-227" data-mp="1vfkpfsc3d6x9">
                  Only <span className="text-before" data-id="element-228" data-mp="1vgcawabz5o9t">{SPOTS_LEFT} spots left</span> at the promotional price
                </span>
                <span className="text-before" data-id="element-229" data-mp="2j7867hfn31lt">{Math.round(filled)}%</span>
              </div>
              <div className="h-4 w-full overflow-hidden rounded-full bg-panel" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-230" data-mp="2o3gkksm0iqrx">
                <div className="h-full rounded-full bg-before" style={{
                width: `${filled}%`
              }} data-id="element-231" data-mp="36upswyk1r9hx" />
              </div>
            </div>

            <CtaButton className="mt-7" label="Get the Blueprint™ for $27" data-id="element-232" data-mp="1j41p9ord1kb7" />
            <Countdown data-id="element-233" data-mp="1e5qijmwd3px7" />

            <ul className="mt-6 grid gap-2 text-[14px] text-mist sm:grid-cols-2" data-id="element-234" data-mp="1e9o0w6b48dg1">
              {["Digital download", "No monthly subscription", "Access to the purchased files", "7-day satisfaction guarantee"].map(t => <li key={t} className="flex items-center gap-2" data-id="element-235" data-mp="21xfdlb0kishu">
                  <CheckIcon className="h-4 w-4 shrink-0 text-after" strokeWidth={3} aria-hidden="true" data-id="element-236" data-mp="21yqgl8m6vw7w" />
                  {t}
                </li>)}
            </ul>
            <p className="mt-5 flex items-center justify-center gap-2 text-[13px] text-mist" data-id="element-237" data-mp="1s59n65pysj4r">
              <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-238" data-mp="1n7gg7agu7l3f" /> Secure checkout
            </p>
          </div>
        </div>

        <p className="mx-auto mt-6 max-w-xl text-center text-[15px] leading-relaxed text-white" data-id="element-239" data-mp="2kp87r8rdijr5">
          For less than the cost of many professional reference books, get an organized collection designed to support your study of orthopedic test interpretation.
        </p>
        <p className="mx-auto mt-4 max-w-xl text-center text-[12px] leading-relaxed text-mist" data-id="element-240" data-mp="2s7enimb6a1wl">
          Reference values are estimates for offer positioning, not verified retail prices.
        </p>
      </div>
    </section>;
}